import moment from 'moment'

const periodicals = {
  methods: {
    getPeriod (period) {
      switch (period) {
        case 1:
          return this.lang.financial.periodicals.new.periods.monthly
        case 3:
          return this.lang.financial.periodicals.new.periods.quarterly
        case 6:
          return this.lang.financial.periodicals.new.periods.semester
        case 12:
          return this.lang.financial.periodicals.new.periods.annual
        case 24:
          return this.lang.financial.periodicals.new.periods.biannual
        default:
          return this.lang.financial.periodicals.new.periods.unknown
      }
    },
    getDue (item) {
      var now = moment(),
          last = moment.utc((item.last_paid !== null ? item.last_paid : item.created)),
          next = (item.last_paid !== null ? last.add(item.period, 'M').set('date', item.date) : last.set('date', item.date)),
          diff = moment.duration(next.diff(now)),
          days = Math.floor(diff.asDays()),
          color = (days <= 0 && days >= -3 ? 'amber' : (days < 0 ? 'red' : 'green'))

      return {
        color,
        days,
        text: next.format("DD/MM/YYYY"),
        date: next.format("YYYY-MM-DD"),
      }
    },
    save_ () {
      if (this.$refs.SaveForm.validate()) {
        this.$store.dispatch('saveData', { page: 5, data: { subpage: 4, ...this.selected }, item: this.id })
      }
    },
    delete_ (item) {
      this.$store.dispatch('setOverlay', true)
      this.$root.$dialog.confirm({
        text: this.lang.financial.periodicals.dialog.delete(item.title),
        title: this.lang.confirm.title,
        waitForResult: true
      }).then(res => {
        this.$store.dispatch('setOverlay', false)
        if (res) this.$store.dispatch('saveMixed', { page: 5, type: 1, data: { subpage: 4, ...item }, ignoreResponseBar: false })
      })
    }
  }
}
export default periodicals
